<template>
    <div class="orders osago">
        <div class="container">
            <div class="row">
                <div class="row flex-lg-row-reverse">
                    <div class="col-lg-12">
                        <a href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
                            Повернутися до вибору
                        </a>
                        <h1 class="title company_name">
                            Оформлення страхування квартири від {{ offerInfo.companyNamePublic }}
                        </h1>
                        <div class="row">
                            <div class="col-auto">
                                <div class="fill-btn-element">
                                    <div class="icon">
                                        <button @click="fillClientData" class="btn" style="width: 53px">
                                            <div v-if="isfillClientData" class="option-loader spinner-border" style="height: 22px; width: 22px; margin-right: 12px;" role="status"></div>
                                            <svg v-else width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="32" height="32" fill="url(#pattern3)" />
                                                <defs>
                                                    <pattern id="pattern3" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                        <use xlink:href="#image0_561_1706" transform="scale(0.01)" />
                                                    </pattern>
                                                    <image id="image0_561_1706" width="100" height="100" xlink:href="data:image/png;base64,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" />
                                                </defs>
                                            </svg>
                                        </button>
                                    </div>
                                    <i class="icon question" data-html="true" data-placement="bottom" data-select="true" data-toggle="tooltip" title="Заповнення форми"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row flex-lg-row-reverse">
                    <div class="col-lg-4">
                        <div class="sticky-wrapp">
                            <HomePolicy :can-edit="false" />
                            <HomePromo />
                        </div>
                    </div>
                    <form class="col-lg-8 step-block">
                        <div class="row">
                            <div class="col-12">
                                <insurer-info-form
                                    v-model="payer"
                                    @selectInsuredInfo="selectInsuredInfo"
                                    @getClientDataForUpdating="getClientDataForUpdating"
                                    ref="insurerInfoForm"
                                />
                                <DocumentsBlock
                                    :productType="8"
                                    :offerInfo="offerInfo"
                                    :searchInfo="searchInfo"
                                    :documentation="payer.documentation"
                                    :submitCheck="submitCheck"
                                    :dateBirth="payer.dateBirth"
                                    @data-chenged="getClientDataForUpdating"
                                    ref="documentBlock"
                                />
                            </div>
                            <div class="col-12">
                                <insurer-registration-info-form
                                    v-model="payer"
                                    :cities-options="citiesOptions"
                                    @searchCities="searchCities"
                                    @getClientDataForUpdating="getClientDataForUpdating"
                                    ref="insurerRegistrationInfoForm"
                                    :loading="homeCitiesLoading"
                                />
                            </div>
                            <div class="col-12">
                                <insurance-home-info-form
                                    v-model="homeInfo"
                                    :cities-options="homeCitiesOptions"
                                    @searchCities="searchHomeCities"
                                    @getClientDataForUpdating="getClientDataForUpdating"
                                    ref="insurerHomeInfoForm"
                                    :loading="homeCitiesLoading"
                                />
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="row col-lg-12 order-nav">
                                        <div class="col-lg-12 text-center">
                                            <button type="button" class="btn btn-blue" @click="submitHandler('nextFinal')">
                                                Перейти до наступного кроку
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <animationModal />
        <modal-success @dataDraftUrl="getDraftUrl()" @next="nextStep()"></modal-success>
        <clients-fill-data-func
            :show-fill-client-data-modal="showFillClientDataModal"
            :clien-data="selectedPibInn"
            :search-info="searchInfo"
            :offer-info="offerInfo"
            :product-type="productType"
            @close="showFillClientDataModal = false"
            @save="saveFillData"
        />
    </div>
</template>

<script>
import ClientsFillDataFunc from "@/components/app/clients/clientsFillDataFunc.vue";
import animationModal from "@/components/app/modals/modal-draftAnimation.vue";
import DocumentsBlock from "@/components/app/forms/DocumentsBlock.vue";
import InsurerInfoForm from "@/views/home/components/InsurerInfoForm.vue";
import Multiselect from "vue-multiselect";
import { documentMixin } from "@/mixin";
import InsuranceHomeInfoForm from "@/views/home/components/InsuranceHomeInfoForm.vue";
import InsurerRegistrationInfoForm from "@/views/home/components/InsurerRegistrationInfoForm.vue";
import {saveClient} from "@/api/client";
import axios from "axios";
import {orderHome} from "@/api/orderHome";
import modalSuccess from "@/components/app/modals/modal-draft-success.vue";
import HomePolicy from "@/views/home/components/HomePolicy.vue";
import HomePromo from "@/views/home/components/HomePromo.vue";

export default {
    mixins: [documentMixin],
    components: {
        HomePromo,
        HomePolicy,
        modalSuccess,
        InsurerRegistrationInfoForm,
        InsuranceHomeInfoForm,
        InsurerInfoForm,
        Multiselect,
        DocumentsBlock,
        animationModal,
        ClientsFillDataFunc
    },

    data() {
        return {
            fetchClientsTimeout: null,
            selectedPibInn: false,
            isfillClientData: false,
            showFillClientDataModal: false,
            isfillData: false,
            searchInfo: null,
            clientId: null,
            productType: 'home',
            orderId: null,
            payer: {
                identificationCode: null,
                withoutDocuments: false,
                name_ua: null,
                surname_ua: null,
                patronymic_ua: null,
                dateBirth: false,
                phone: null,
                mail: null,
                city: null,
                street: null,
                house: null,
                apartment: null,
                documentType: 1,
                passportSerial: null,
                passportNumber: null,
                passportDate: null,
                withoutIdentificationCode: false,
                documentation: {
                    type: 1,
                    serial: null,
                    number: null,
                    issuedBy: null,
                    dateOfIssue: null,
                    endDateOfIssue: null,
                    dateOfIssueError: false,
                    documentType: null,
                },
            },
            homeInfo: {
                city: null,
                street: null,
                house: null,
                apartment: null,
            },
            submitCheck: false,
            LetterMaskError: false,
            isLoadInsuredsListBySurname: false,
            isLoadInsuredsByCompanyName: false,
            insuredsListBySurname: {},
            errors: [],
            isLoadInsuredsList: false,
            insuredsList: {},
            homeCitiesOptions: [
                { id: 5047, name: "м. Київ", name_full_name_ua: "м. Київ, Київ область, Україна", region: 'Київ' },
                { id: 6847, name: "м. Львів", name_full_name_ua: "м. Львів, Львівська область, Україна", region: 'Львівська' },
                { id: 3, name: "м. Вінниця", name_full_name_ua: "м. Вінниця, Вінницька область, Україна", region: 'Вінницька' },
                { id: 15360, name: "м. Чернігів", name_full_name_ua: "м. Чернігів, Чернігівська область, Україна", region: 'Чернігівська' },
                { id: 15360, name: "м. Полтава", name_full_name_ua: "м. Полтава, Полтавська область, Україна", region: 'Полтавська' },
                { id: 12894, name: "м. Хмельницький", name_full_name_ua: "м. Хмельницький, Хмельницька область, Україна", region: 'Хмельницька' },
                { id: 14173, name: "м. Черкаси", name_full_name_ua: "м. Черкаси, Черкаська область, Україна", region: 'Черкаська' },
                { id: 14953, name: "м. Чернівці", name_full_name_ua: "м. Чернівці, Чернівецька область, Україна", region: 'Чернівецька' },
                { id: 2298, name: "м. Житомир", name_full_name_ua: "м. Житомир, Житомирська область, Україна", region: 'Житомирська' },
                { id: 10981, name: "м. Рівне", name_full_name_ua: "м. Рівне, Рівненська область, Україна", region: 'Рівненська' },
            ],
            citiesOptions: [
                { id: 1, name: "Київ", name_full_name_ua: "м. Київ, Україна", zone: 1 },
                { id: 9, name: "Дніпро", name_full_name_ua: "м. Дніпро, Дніпропетровська обл., Україна", zone: 2 },
                { id: 11, name: "Львів", name_full_name_ua: "м. Львів, Львівська обл., Україна", zone: 1 },
                { id: 13, name: "Одеса", name_full_name_ua: "м. Одеса, Одеська обл., Україна", zone: 2 },
                { id: 14, name: "Харків", name_full_name_ua: "м. Харків, Харківська обл., Україна", zone: 2 },
                { id: 16, name: "Запоріжжя", name_full_name_ua: "м. Запоріжжя, Запорізька обл., Україна", zone: 3 },
                { id: 17, name: "Кривий Ріг", name_full_name_ua: "м. Кривий Ріг, Дніпропетровська обл., Україна", zone: 3 },
                { id: 21, name: "Вінниця", name_full_name_ua: "м. Вінниця, Вінницька обл., Україна", zone: 4 },
                { id: 36, name: "Маріуполь", name_full_name_ua: "м. Маріуполь, Донецька обл., Україна", zone: 4 },
                { id: 41, name: "Полтава", name_full_name_ua: "м. Полтава, Полтавська обл., Україна", zone: 4 },
            ],
            homeCitiesLoading: false,
        };
    },

    created() {
        this.searchInfo = this.$store.getters.HOME_SEARCH_PARAMS;
        this.fetchInfo(this.$store.getters.HOME_INFO_USER);
        this.homeInfo = this.$store.getters.HOME_HOUSE_INFO;

        if (this.$store.getters.GET_CLIENT) {
            this.clientId = this.$store.getters.GET_CLIENT.id;
        }

        if (!!this.$store.getters.HOME_FULL_ORDER) {
            this.orderId = this.$store.getters.HOME_FULL_ORDER.orderId;
        }
    },

    computed: {
        offerInfo() {
            return this.$store.getters.HOME_INFO_OFFER;
        },
    },

    methods: {
        updateStore(offerInfo){
            this.$store.commit('SET_HOME_INFO_OFFER', offerInfo);
            this.$store.commit('SET_HOME_FULL_ORDER', offerInfo.orderId);
        },

        fillClientData() {
            this.showFillClientDataModal = true;
        },

        saveFillData(params) {
            this.showFillClientDataModal = false;
            this.fillFormFromClientData(params.selectPibInn, params.selectHome, params.selectDocument);
        },

        async fillFormFromClientData(selectPibInn, selectHome, selectDocument) {
            this.isfillData = true;
            this.$store.commit('SET_CLIENT', selectPibInn.id);
            let fio =  selectPibInn.fio.split(" ");

            this.payer.surname_ua = fio[0];
            this.payer.name_ua = fio[1];
            this.payer.patronymic_ua = fio[2];

            this.payer.phone = selectPibInn.phone;
            this.payer.mail = selectPibInn.email;

            this.payer.dateBirth = (selectPibInn.date_of_birth) ? moment(selectPibInn.date_of_birth, 'DD-MM-YYYY').format('DD.MM.YYYY') : null;

            if(selectDocument){
                this.payer.documentation.type = selectDocument.document_type;
                this.payer.documentation.serial = selectDocument.serial;
                this.payer.documentation.number = selectDocument.number;
                this.payer.documentation.issuedBy = selectDocument.issued_by;
                this.payer.documentation.dateOfIssue = (selectDocument.date_of_issue) ? moment(selectDocument.date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
                this.payer.documentation.endDateOfIssue = (selectDocument.end_date_of_issue) ? moment(selectDocument.end_date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
            }

            if (selectHome) {
                this.homeInfo.city = selectHome.city;
                this.homeInfo.street = selectHome.street;
                this.homeInfo.house = selectHome.house;
                this.homeInfo.apartment = selectHome.apartment;
            }

            this.payer.street = selectPibInn.street;
            this.payer.house = selectPibInn.house;
            this.payer.city = selectPibInn.city;
            this.payer.identificationCode = selectPibInn.identification_number;
            this.payer.withoutIdentificationCode = (selectPibInn.identification_number) ? false : true;
            this.payer.apartment = selectPibInn.flat;

            this.insuredsList = [];
            this.insuredsListByErdpyCode = [];

            this.$nextTick(() => {
                this.isfillData = false;
            });
        },

        getClientDataForUpdating() {
            if (this.isfillData == false) {
                const orderData = this.getOrderData();
                this.updateClientData(orderData);
            }
        },

        onlyLatinCharactersAndNum(str) {
            if (str == undefined || str == null || str == "") return true;
            return /^[a-zA-Z0-9 ]+$/.test(str);
        },

        selectInsuredInfo(insured) {
            this.isfillData = true;
            this.selectedPibInn = insured;
            this.clientId = insured.id;

            let selectDocument = false;
            let selectHouse = false;
            insured.documents = this.getAllowedDocumentsTypes(insured.documents);

            if (insured.documents.length === 1) {
                selectDocument = insured.documents[0];
            }

            const params = {
                selectPibInn: insured,
                selectDocument: selectDocument,
                selectHouse: selectHouse,
            }

            if (!selectDocument || !selectHouse) {
                this.fillClientData();
                this.isfillData = false;

                return;
            }

            this.$store.commit('SET_CLIENT', insured.id);
            this.saveFillData(params);
            this.isfillData = false;
        },

        hasError(name, index = false) {
            if (!index) {
                return this.errors[name] !== undefined;
            } else {
                if (!!this.errors[name]) {
                    return this.errors[name][index] !== undefined;
                } else {
                    return false;
                }
            }
        },

        errorBirthDate() {
            if (this.payer.dateBirth == "" || this.payer.dateBirth == null) {
                return false;
            }
            if ((parseInt(moment(this.payer.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) < 18) {
                this.errors['payer.errorBirthDate'] = ["Страхувальнику повинно бути більше 18 років"];
                return true;
            } else if ((parseInt(moment(this.payer.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years') - 1) * -1) > 100) {
                this.errors['payer.errorBirthDate'] = ["Страхувальнику повинно бути не більше 100 років"];
                return true;
            } else {
                delete this.errors['payer.errorBirthDate'];
            }
            return false;
        },

        submitHandler(type) {
            this.submitCheck = true;

            if (this.$refs.insurerInfoForm.$v.$invalid) {
                this.$refs.insurerInfoForm.$v.$touch();
                this.$refs.insurerInfoForm.$el.scrollIntoView({block: 'center', behavior: 'smooth'});
            }

            if (this.$refs.documentBlock.$v.$invalid) {
                this.$refs.documentBlock.$v.$touch();
                this.$refs.documentBlock.$el.scrollIntoView({behavior: 'smooth'});
            }

            if (this.$refs.insurerRegistrationInfoForm.$v.$invalid) {
                this.$refs.insurerRegistrationInfoForm.$v.$touch();
                this.$refs.insurerRegistrationInfoForm.$el.scrollIntoView({behavior: 'smooth'});
            }

            if (this.$refs.insurerHomeInfoForm.$v.$invalid) {
                this.$refs.insurerHomeInfoForm.$v.$touch();
                this.$refs.insurerHomeInfoForm.$el.scrollIntoView({behavior: 'smooth'});
            }

            if (this.$refs.insurerInfoForm.$v.$invalid || this.$refs.documentBlock.$v.$invalid
                || this.$refs.insurerHomeInfoForm.$v.$invalid || this.$refs.insurerRegistrationInfoForm.$v.$invalid) {

                return;
            }

            const balance = this.$store.getters.ALL_TRANSACTIONS.amount - this.$store.getters.ALL_TRANSACTIONS.creditLimit
            if (balance < this.offerInfo.fullPrice && type !== 'save') {
                this.$alert('Підписання договору неможливо, недостатньо коштів на рахунку', '', 'error');

                return;
            }

            this.searchInfo.startDate = this.formatDate(this.searchInfo.startDate);
            this.offerInfo.allowed_documents = this.offerInfo.available_documents ?? this.offerInfo.allowed_documents ?? null;
            let offerInfo = Object.assign({}, this.offerInfo);
            const searchInfo = {
                startDate: this.searchInfo.startDate,
                homeType: this.searchInfo.homeType.param,
                insuranceAmount: this.searchInfo.insuranceAmount.param,
                insurancePeriod: this.searchInfo.insurancePeriod.param,
                earnings: this.searchInfo.earning.value,
            };
            const userInfo = Object.assign({}, this.payer);
            const houseInfo = Object.assign({}, this.homeInfo);

            const params = {
                type: type,
                statusId: 1,
            };

            if (['save', 'nextFinal'].includes(type)) {
                this.showAnimateModal();
            }
            offerInfo.orderId = this.orderId;

            let discountDetails = {
                dynamicDiscountPrice: 0,
                dynamicDiscountPercent: 0,
                dynamicDiscountedSum: 0,
                dynamicEarnings: 0
            };

            if(offerInfo.dynamicDiscountPrice > 0) {
                discountDetails.dynamicDiscountPrice = +parseFloat(offerInfo.dynamicDiscountPrice).toFixed(2);
                discountDetails.dynamicDiscountPercent = +parseFloat(offerInfo.dynamicDiscountPercent).toFixed(2);
                discountDetails.dynamicDiscountedSum = +parseFloat(offerInfo.dynamicDiscountedSum).toFixed(2);
                discountDetails.dynamicEarnings = +parseFloat(offerInfo.dynamicEarnings).toFixed(2);
                discountDetails.earnings = +parseFloat(offerInfo.earnings).toFixed(2);

                offerInfo.discountDetails = discountDetails;
                offerInfo = {...offerInfo, ...discountDetails};
            } else {
                offerInfo.discountDetails = null;
                offerInfo = {...offerInfo, ...discountDetails};
            }

            this.updateStore(offerInfo);

            this.$store.commit('SET_HOME_INFO_OFFER', offerInfo);
            this.$store.commit('SET_HOME_INFO_USER', userInfo);
            this.$store.commit('SET_HOME_INFO_HOUSE', houseInfo);

            this.getClientDataForUpdating();

            orderHome(offerInfo, searchInfo, userInfo, houseInfo, this.orderId, params).then((response) => {
                if (response?.data?.data[0]?.status == "sanctioned") {
                    this.$alert(
                        `<div class="sanctions-alert-content">
                             <p>Данного клієнта знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка</p>
                             <p><strong>Ім'я:</strong> ${response?.data?.data[0]?.message?.name || response?.data?.data[0]?.message[0]?.name || 'Немає даних'}</p>
                             <p><strong>Дата народження:</strong> ${response?.data?.data[0]?.message?.birthdate || response?.data?.data[0]?.message[0]?.birthdate || 'Немає даних'}</p>
                             <p><strong>Документи:</strong> ${response?.data?.data[0]?.message?.identity_docs || response?.data?.data[0]?.message[0]?.identity_docs || 'Немає даних'}</p>
                             <p><strong>Санкції:</strong> ${response?.data?.data[0]?.message?.sanctions || response?.data?.data[0]?.message[0]?.sanctions || 'Немає даних'}</p>
                           </div>`,
                        'Санкції!',
                        {
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass: 'sanctions-alert'
                        }
                    );

                    return false;
                }
                if (response?.data?.data[0]?.status ==  "possible_match") {
                    this.$alert(
                        `<div class="sanctions-alert-content">
                             <p>Данного клієнта вірогідно знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка</p>
                             <p><strong>Ім'я:</strong> ${response?.data?.data[0]?.message?.name || response?.data?.data[0]?.message[0]?.name || 'Немає даних'}</p>
                             <p><strong>Дата народження:</strong> ${response?.data?.data[0]?.message?.birthdate || response?.data?.data[0]?.message[0]?.birthdate || 'Немає даних'}</p>
                             <p><strong>Документи:</strong> ${response?.data?.data[0]?.message?.identity_docs || response?.data?.data[0]?.message[0]?.identity_docs || 'Немає даних'}</p>
                             <p><strong>Санкції:</strong> ${response?.data?.data[0]?.message?.sanctions || response?.data?.data[0]?.message[0]?.sanctions || 'Немає даних'}</p>
                           </div>`,
                        'Санкції!',
                        {
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass: 'sanctions-alert'
                        }
                    );

                    return false;
                }

                this.orderId  = response?.data?.data[0]?.id;
                this.$store.commit('SET_HOME_FULL_ORDER', response.data.data[0].id);

                if (type == 'save') {
                    $('#modalPayAnimation').modal('hide');
                    this.draftUrl = response.data?.data[1]?.contractDraft_path;
                    $('#modalFlightSuccess').modal('show');

                    return;
                }

                if (type === 'nextFinal') {
                    this.$router.push({name: 'homeFinnaly'});
                } else {
                    this.$alert('Чернетка успішно збережена.')
                }

                $('#modalPayAnimation').modal('hide');
            }).catch((error) => {
               $('#modalPayAnimation').modal('hide');
               if (error?.response?.data?.data?.orderId?.[0]?.includes('недостатньо коштів')) {
                   this.$alert(error?.response?.data?.data?.orderId[0], 'Недостатньо коштів', 'error');
               } else if (error?.response?.data?.message) {
                   this.$alert('Помилка при збереження чернетки', '', 'error');
               }
            });
        },

        formatDate(date) {
            if (date.match(/^\d{2}\.\d{2}\.\d{4}$/)) {
                // Заменяем точки на дефисы
                date = date.replace(/\./g, '-');
            }
            return date;
        },

        searchHomeCities(query) {
            if(query.length > 1){
                this.fetchHomeCities(query);
            }
        },

        fetchHomeCities(query) {
            this.homeCitiesLoading = true;
            if (query) {
                axios.get('/api/directories/home/cities/find?city=' + query)
                    .then(({data}) => {
                        this.homeCitiesOptions = data.data;
                        this.homeCitiesLoading = false;
                    })
                    .catch(() => { this.homeCitiesLoading = false; });
            } else {
                axios.get('/api/directories/home/cities/all')
                    .then(({data}) => {
                        this.homeCitiesOptions = data.data;
                        this.homeCitiesLoading = false;
                    })
                    .catch(() => { this.homeCitiesLoading = false; });
            }
        },

        searchCities(query) {
            if(query.length > 1){
                this.fetchCities(query);
            }
        },

        fetchCities(query) {
            axios.get('/api/directories/cities/find?city=' + query).then(({data}) => {
                this.citiesOptions = data.data;

                if (this.citiesOptions.length === 0) {
                    this.citiesOptions.push(this.otherCity);
                }
            });
        },

        fetchInfo(data) {
            if (data) {
                this.payer = data;
                this.payer.documentation.type = this.convertationDocumentType(this.payer.documentation.type) ?? data.documentType;
            }
        },

        convertationDocumentType(DocumentType) {
            return this.convertDocumentToNumber(DocumentType);
        },

        getOrderData() {
            this.searchInfo.startDate = this.formatDate(this.searchInfo.startDate);
            this.offerInfo.allowed_documents = this.offerInfo.available_documents ?? this.offerInfo.allowed_documents ?? null;
            let info = JSON.parse(JSON.stringify(this.payer));

            info.phone = (info.phone == '+38 (0') ? "" : info.phone;

            return {
                'searchInfo': this.searchInfo,
                'offerInfo': this.offerInfo,
                'homeInfo': this.homeInfo,
                'info': info,
                'orderId': this.orderId,
                'clientId': this.clientId,
                'productType': this.productType
            };
        },

        updateClientData(orderData) {
            if (this.isfillData) return;

            if (
                (this.payer.identificationCode && this.payer.identificationCode.length === 10) || (this.payer.erdpyCode && this.payer.erdpyCode.length === 8) ||
                (((this.payer.phone !== null && this.payer.phone !== "+38 (0" && this.payer.phone.length === 19) ||
                        (this.payer.mail !== null && this.userData.email !== "" && !this.$v.payer.mail.$invalid))
                    && this.payer.surname_ua !== null && this.payer.name_ua !== null && this.payer.patronymic_ua !== null)
            ) {
                orderData = (orderData instanceof Event || !orderData) ? this.getOrderData() : orderData;

                if (orderData) {
                    saveClient(orderData).then(response => {
                        if (response?.data?.status == "success") {
                            this.clientId = response?.data?.data?.id;
                            this.$store.commit('SET_CLIENT', this.clientId);
                            this.$store.commit('SET_HOME_FULL_ORDER', this.orderId);
                        }
                    });
                }
            }
        },

        showAnimateModal() {
            $("#modalPayAnimation").modal({
                backdrop: "static",
                keyboard: true,
                show: true,
            });

            let i = 0;

            if (i == 0) {
                i = 1;
                let width = 1;
                let id = setInterval(frame, 200);

                function frame() {
                    if (width >= 99) {
                        clearInterval(id);
                        i = 0;
                    } else {
                        width += 2;
                        $(".results_anime_percent-text").text(`${width}%`);
                        $(".results_anime_line-scale").css({width: `${width}%`});
                    }
                }
            }
        },

        getDraftUrl() {
            window.open(`/api/orders/draft/${this.$store.getters.USER.id}/${this.orderId}`);
        },

        nextStep() {
            $('#modalFlightSuccess').modal('hide');
            $('#modalPayAnimation').modal('hide');
            this.$router.push({name: 'homeFinnaly'});
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
